module.exports = __webpack_public_path__ + "static/media/others1.9cb1c193.png";